(() => {
  const SELECTOR = '[data-ac-search-modal]';
  const SEARCHANISE_SELECTOR = '.snize-ac-results, .snize-ac-results-mobile';

  function initModal(modal) {
    if (!modal || modal.dataset.acSearchReady === 'true') return;
    modal.dataset.acSearchReady = 'true';

    const id = modal.id;
    const trigger = document.querySelector(`[aria-controls="${CSS.escape(id)}"][data-ac-search-open]`);
    const closeButtons = modal.querySelectorAll('[data-ac-search-close]');
    const input = modal.querySelector('[data-live-search-input]');
    const starter = modal.querySelector('[data-ac-search-starter]');
    const resultsHost = modal.querySelector('[data-ac-search-results-host]');
    const panel = modal.querySelector('.ac-search-modal__panel');
    const form = modal.querySelector('.live-search-form');
    const recentSection = modal.querySelector('[data-ac-search-recent-section]');
    const recentList = modal.querySelector('[data-ac-search-recent-list]');
    const clearRecentButton = modal.querySelector('[data-ac-search-clear-recent]');
    const quickQueryButtons = modal.querySelectorAll('[data-ac-search-query]');
    const RECENT_KEY = 'ac_recent_searches';
    let returnFocus = null;
    let observer = null;

    const getRecentSearches = () => {
      try {
        const parsed = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
        return Array.isArray(parsed) ? parsed.filter((item) => typeof item === 'string' && item.trim()).slice(0, 4) : [];
      } catch (error) {
        return [];
      }
    };

    const saveRecentSearches = (items) => {
      try {
        window.localStorage.setItem(RECENT_KEY, JSON.stringify(items.slice(0, 4)));
      } catch (error) {
        /* localStorage can be unavailable in strict privacy modes; search still works. */
      }
    };

    const addRecentSearch = (query) => {
      const clean = String(query || '').trim().replace(/\s+/g, ' ');
      if (!clean) return;
      const current = getRecentSearches().filter((item) => item.toLowerCase() !== clean.toLowerCase());
      saveRecentSearches([clean, ...current]);
      renderRecentSearches();
    };

    const runQuery = (query, remember = true) => {
      const clean = String(query || '').trim();
      if (!input || !clean) return;
      input.value = clean;
      if (remember) addRecentSearch(clean);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus({ preventScroll: true });
      if (typeof input.setSelectionRange === 'function') {
        input.setSelectionRange(clean.length, clean.length);
      }
    };

    const renderRecentSearches = () => {
      if (!recentSection || !recentList) return;
      const items = getRecentSearches();
      recentList.innerHTML = '';
      recentSection.hidden = items.length === 0;
      items.forEach((query) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ac-search-modal__recent-item';
        button.dataset.acRecentQuery = query;
        button.innerHTML = `<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4.5 7.5A6 6 0 1 1 4 12" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M3.5 4v4h4" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg><span></span>`;
        button.querySelector('span').textContent = query;
        button.addEventListener('click', () => runQuery(query, true));
        recentList.appendChild(button);
      });
    };

    const syncStarter = () => {
      if (!starter || !input) return;
      starter.hidden = input.value.trim().length > 0;
    };

    const adoptSearchaniseResults = () => {
      if (!resultsHost) return;

      document.querySelectorAll(SEARCHANISE_SELECTOR).forEach((results) => {
        if (resultsHost.contains(results)) return;
        if (results.closest('[data-ac-search-modal]') && !modal.contains(results)) return;

        results.dataset.acSearchaniseHosted = 'true';
        resultsHost.appendChild(results);

        /* Searchanise calculates document-level dropdown coordinates inline.
           Clear the inline geometry after moving it into our modal host. */
        ['top', 'right', 'bottom', 'left', 'width', 'minWidth', 'maxWidth', 'transform', 'zIndex'].forEach((prop) => {
          results.style.removeProperty(prop.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`));
        });
      });
    };

    const startSearchaniseObserver = () => {
      if (observer) return;
      observer = new MutationObserver(() => adoptSearchaniseResults());
      observer.observe(document.body, { childList: true, subtree: true });
      adoptSearchaniseResults();
    };

    const open = () => {
      returnFocus = document.activeElement;
      /* Empire's ScrollLock only permits touch scrolling inside this class. */
      if (panel) panel.classList.add('allow-scroll-while-locked');
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ac-search-modal-open');
      startSearchaniseObserver();
      renderRecentSearches();

      requestAnimationFrame(() => {
        modal.classList.add('is-open');
        window.setTimeout(() => {
          adoptSearchaniseResults();
          if (input) {
            input.focus({ preventScroll: true });
            if (typeof input.select === 'function' && input.value) input.select();
          }
          syncStarter();
        }, 60);
      });
    };

    const close = () => {
      if (modal.hidden) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');

      /* Blur/focus outside the embedded Empire live-search before releasing our
         scoped dimmer override. That gives Empire a chance to close its own
         flydown, clear SiteMainDimmer and unlock its ScrollLock cleanly. */
      if (input && document.activeElement === input) input.blur();

      window.setTimeout(() => {
        if (input) {
          input.value = '';
          input.dispatchEvent(new Event('input', { bubbles: true }));
          syncStarter();
        }
        modal.hidden = true;
        if (returnFocus && typeof returnFocus.focus === 'function') {
          returnFocus.focus({ preventScroll: true });
        }

        window.setTimeout(() => {
          document.body.classList.remove('ac-search-modal-open');
          if (panel) panel.classList.remove('allow-scroll-while-locked');
        }, 0);
      }, 190);
    };

    if (trigger) trigger.addEventListener('click', open);
    closeButtons.forEach((button) => button.addEventListener('click', close));

    quickQueryButtons.forEach((button) => {
      button.addEventListener('click', () => runQuery(button.dataset.acSearchQuery, true));
    });

    if (clearRecentButton) {
      clearRecentButton.addEventListener('click', () => {
        saveRecentSearches([]);
        renderRecentSearches();
        if (input) input.focus({ preventScroll: true });
      });
    }

    if (form) {
      form.addEventListener('submit', () => {
        if (input) addRecentSearch(input.value);
      });

      /* Empire's live-search JS can consume the search-icon click while the
         predictive search is open. Re-submit the form explicitly so clicking
         the magnifying-glass button behaves exactly like pressing Enter. */
      const submitButton = form.querySelector('[data-live-search-submit]');
      if (submitButton) {
        submitButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!input || !input.value.trim()) {
            if (input) input.focus({ preventScroll: true });
            return;
          }
          addRecentSearch(input.value);
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        }, true);
      }
    }

    if (input) {
      const handleInput = () => {
        syncStarter();
        /* Searchanise may build/rebuild the result node after each query. */
        window.setTimeout(adoptSearchaniseResults, 0);
        window.setTimeout(adoptSearchaniseResults, 80);
        window.setTimeout(adoptSearchaniseResults, 220);
      };
      input.addEventListener('input', handleInput);
      input.addEventListener('search', handleInput);
      input.addEventListener('focus', () => window.setTimeout(adoptSearchaniseResults, 60));
    }

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')]
        .filter((el) => !el.hidden && el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function initAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
